export default (state: any, action: any) => ({
  ...state,
  healthcare: {
    ...state.leadsPool,
    isSaving: action.isSaving,
  },
});
